import { render, staticRenderFns } from "./Pulpit.vue?vue&type=template&id=3dd535ad&scoped=true&"
import script from "./Pulpit.vue?vue&type=script&lang=js&"
export * from "./Pulpit.vue?vue&type=script&lang=js&"
import style0 from "./Pulpit.vue?vue&type=style&index=0&id=3dd535ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd535ad",
  null
  
)

export default component.exports